import React from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "../layout/Layout";
import PageBanner from "../layout/PageBanner";
import { Panel, money } from "../components/ui";

export default function OrderSuccess() {
  const { state } = useLocation();

  return (
    <Layout>
      <PageBanner title="ทำรายการสำเร็จ" breadcrumb={[{ label: "ผลการทำรายการ" }]} seed={16} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel style={{ maxWidth: 640, margin: "0 auto", textAlign: "center" }}>
          <div
            style={{
              width: 86,
              height: 86,
              borderRadius: "50%",
              background: "linear-gradient(140deg, var(--lt-teal), var(--lt-cyan))",
              color: "#fff",
              fontSize: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 18px",
            }}
          >
            ✓
          </div>
          <h2 className="lt-panel__title">{state?.title || "ทำรายการสำเร็จ"}</h2>
          <p className="lt-text-muted">{state?.detail}</p>

          <div className="lt-summary" style={{ textAlign: "left" }}>
            <div className="lt-summary__row">
              <span>เลขที่คำสั่งซื้อ</span>
              <span>{state?.orderCode || "-"}</span>
            </div>
            <div className="lt-summary__row lt-summary__row--total">
              <span>ยอดชำระ</span>
              <span>฿ {money(state?.total || 0)}</span>
            </div>
          </div>

          <div className="lt-flex lt-gap-12 lt-mt-24">
            <Link to="/" className="lt-btn lt-btn--ghost" style={{ flex: 1 }}>
              กลับหน้าหลัก
            </Link>
            <Link to={state?.historyPath || "/profile"} className="lt-btn lt-btn--primary" style={{ flex: 1 }}>
              ดูประวัติคำสั่งซื้อ
            </Link>
          </div>
        </Panel>
      </div>
    </Layout>
  );
}
